<script setup lang="ts">
  import type { RefComponent } from '@/types'

  import { computed, defineAsyncComponent, onMounted, ref } from 'vue'
  import { useRoute } from 'vue-router'

  import { storeToRefs } from 'pinia'
  import { useUiStore } from '@/stores/ui'

  import TheCustomerHeader from '@/layouts/TheCustomerLayout/TheCustomerHeader.vue'
  import TheCustomerFooter from '@/layouts/TheCustomerLayout/TheCustomerFooter.vue'

  import ManagerToast from '@/components/Global/Manager/ManagerToast.vue'
  import CustomerCookieToast from '@/components/Global/Customer/CustomerCookieToast.vue'

  import CustomerCurtainCart from '@/components/Modals/Customer/CustomerCurtainCart.vue'
  import CustomerPopupBanner from '@/components/Modals/Customer/CustomerPopupBanner.vue'
  import CustomerPopupBanner2 from '@/components/Modals/Customer/CustomerPopupBanner2.vue'

  const TheCustomerSidebar = defineAsyncComponent(
    () => import('@/layouts/TheCustomerLayout/TheCustomerSidebar.vue')
  )
  const CustomerModalSearch = defineAsyncComponent(
    () => import('@/components/Modals/Customer/CustomerModalSearch.vue')
  )
  const CustomerCurtainLogin = defineAsyncComponent(
    () =>
      import(
        '@/components/Modals/Customer/CurtainLogin/CustomerCurtainLogin.vue'
      )
  )
  /**
   * Нужно инициализировать стор, чтобы из локального хранилища браузера забирались данные
   * */
  const ui = useUiStore()
  const { cookieAccepted } = storeToRefs(ui)

  const route = useRoute()
  const routeName = computed(() => route.name as string)
  /**
   * Global components visibility
   * */
  const isCheckout = computed(() => /customer-checkout/.test(routeName.value))
  const isOrder = computed(() => /customer-order/.test(routeName.value))
  const isLoyalty = computed(() => /customer-loyalty/.test(routeName.value))

  const canShowHeader = computed(() => !isOrder.value)
  const canShowCart = computed(() => !isCheckout.value && !isOrder.value)

  const sidebarMenu: RefComponent<typeof TheCustomerSidebar> = ref(null)

  function openPopup() {
    ui.popupBannerVisibility2 = true
  }

  onMounted(() => {
    if (!cookieAccepted.value) {
      ui.toggleCookieToast()
    }

    setTimeout(() => {
      openPopup()
    }, 10000)
  })
</script>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'TheCustomerLayout',
  })
</script>

<template>
  <div class="customer-page">
    <template v-if="canShowHeader">
      <!-- Header -->
      <TheCustomerHeader
        :show-only-arrow="isCheckout || isLoyalty"
        :show-sidebar-menu="sidebarMenu?.show"
      />
      <!-- Sidebar menu -->
      <TheCustomerSidebar v-if="!isCheckout && !isLoyalty" ref="sidebarMenu" />
    </template>
    <!-- Page Content -->
    <main class="min-h-[80vh]">
      <slot />
    </main>
    <!-- Popup-banner -->
    <CustomerPopupBanner2 />
    <CustomerPopupBanner ref="popupBannerRef" />
    <!-- Search -->
    <CustomerModalSearch />
    <!-- Cart -->
    <CustomerCurtainCart v-if="canShowCart" />
    <!-- Login -->
    <CustomerCurtainLogin />
    <!-- Footer -->
    <TheCustomerFooter />
  </div>

  <ManagerToast />
  <CustomerCookieToast />
</template>

<style>
  main {
    min-height: 320px;
  }
</style>
